import React from 'react'

import Modal from 'react-bootstrap/Modal'

import AsyncSelect from "../common/AsyncSelect"

import Backend from '../../../utils/Backend'
import General from '../../../utils/General'
import Notify from '../../../utils/Notify'

export default class LinkedAccountModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      ...this._getState(props),
      show: props.show,
      loading: false,
      error: null,
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    return {
      ...props,
      linkedUser: {
        from_user: null,
        company: null,
        role: null
      },
    }
  }

  _getMemberOption(member){
    if(!member) return null

    return {
      value: member.user.id,
      label: `${member.company.name} - ${member.user.first_name} ${member.user.last_name}`,
      data: member
    }
  }

  _isFormValid(){
    let {
      linkedUser
    } = this.state

    let error = null

    if(!linkedUser.from_user){
      error = "Please select a company member"
    }else if(!linkedUser.company){
      error = "Please select a company"
    }else if(!linkedUser.role){
      error = "Please select a role"
    }

    if(error){
      Notify.error(error)
      return false
    }
    return true
  }

  _handleSave(){
    if(!this._isFormValid()){
      return
    }

    this._createLinkedUser()
  }

  _createLinkedUser(){
    let {
      linkedUser
    } = this.state

    const data = {
      from_user: linkedUser.from_user.user.id,
      company: linkedUser.company.id,
      role: linkedUser.role.id
    }

    this.setState({ loading: true })
    Backend.createLinkedUser(data)
    .then(linkedUser => {
      Notify.success("Account Group Created Successfully")
      this.setState({ loading: false })
      this.props.onAdded(linkedUser)
    })
    .catch(error => {
      this.setState({ loading: false })
      Notify.error(error.message)
    })
  }

  render() {
    let {
      show,
      loading,
      error,
      linkedUser,
    } = this.state

    if(!linkedUser) return null

    let title = "Create Linked Account";
    let buttonTitle = "Create";

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        className={""}
        dialogClassName={"modal-dialog modal-dialog-centered modal-lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {error && (
            <div className="form-group">
              <span className="error-message">{error}</span>
            </div>
          )}

          <div className="form-group row">
            <label className="col-3 col-form-label">User*</label>
            <div className="col-9">
              <AsyncSelect
                endpoint={window.Api.CompanyMembers}
                className={'custom-async-select__container'}
                classNamePrefix={'custom-async-select'}
                placeholder={'Select A Company Member'}
                value={this._getMemberOption(linkedUser.from_user)}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                orderBy={"company__name"}
                onSelected={member => {
                  linkedUser.from_user = member
                  this.setState({ linkedUser, error: null })
                }}
                getOptions={members => members.map(member => this._getMemberOption(member))}
              />
              <span className="form-text text-muted">
                Select the user who you want to grant access to the another company
              </span>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Target Company*</label>
            <div className="col-9">
              <AsyncSelect
                endpoint={window.Api.Companies}
                className={'custom-async-select__container'}
                classNamePrefix={'custom-async-select'}
                placeholder={'Select A Company'}
                value={General.getSingleAsyncOption(linkedUser.company)}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                onSelected={company => {
                  linkedUser.company = company
                  this.setState({ linkedUser, error: null })
                }}
                getOptions={companies => General.getAsyncOptions(companies)}
              />
              <span className="form-text text-muted">
                Select the company the user will have access to
              </span>
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Role*</label>
            <div className="col-9">
              <AsyncSelect
                key={linkedUser.company?.id}
                endpoint={window.Api.Roles}
                filter={`company_id=${linkedUser.company?.id}`}
                className={'custom-async-select__container'}
                classNamePrefix={'custom-async-select'}
                placeholder={'Select A Role'}
                disabled={!linkedUser.company}
                value={General.getSingleAsyncOption(linkedUser.role)}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                onSelected={role => {
                  linkedUser.role = role
                  this.setState({ linkedUser, error: null })
                }}
                getOptions={roles => roles.map(role => ({
                  value: role.id,
                  label: role.name,
                  data: role,
                }))}
              />
              <span className="form-text text-muted">
                Select the permissions this user should have on the target company
              </span>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary font-weight-bold"
            onClick={() => this.props.onHide()}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-primary font-weight-bold"
            id="add-success"
            disabled={loading}
            onClick={() => this._handleSave()}
          >
            <span className="svg-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <polygon points="0 0 24 0 24 24 0 24"></polygon>
                  <path
                    d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                    fill="#000000"
                    fillRule="nonzero"
                    transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                  ></path>
                </g>
              </svg>
            </span>
            {buttonTitle}
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}
